import React, { PureComponent } from 'react';

export default class EmptyState extends PureComponent {
  render() {
    return (
      <div>Bundle doesn't exist</div>
    );
  }
}